/** Figma focus ring for palette colour stops (Ready-For-Dev node 14943:107582). */
export const PALETTE_STOP_FOCUS_COLOR = '#38bdf8';

export const PALETTE_STOP_FOCUS_SHADOW_BLUR_PX = 2;

export const paletteStopFocusBoxShadow = `0 0 0 2px ${PALETTE_STOP_FOCUS_COLOR}, 0 0 ${String(
  PALETTE_STOP_FOCUS_SHADOW_BLUR_PX
)}px ${PALETTE_STOP_FOCUS_COLOR}`;

export const paletteStopFocusDropShadow = `drop-shadow(0 0 ${String(
  PALETTE_STOP_FOCUS_SHADOW_BLUR_PX
)}px ${PALETTE_STOP_FOCUS_COLOR})`;
